import React from 'react'
import { useTranslation } from 'react-i18next'
import { bewizrStore, profileStore } from '~/stores'
import { observer } from '~/ui/component'
import { EmptyOrFetching, Scroller } from '~/ui/components'
import { AppLayoutConfig } from '~/ui/layouts'
import { layout } from '~/ui/styling'
import ParticipantProfile from './ParticipantProfile'

const ProfileScreen = observer('ProfileScreen', () => {

  const participant   = profileStore.participant
  const bewizrProfile = bewizrStore.authenticated ? bewizrStore.profile : null

  const fetching = bewizrStore.authenticated && bewizrProfile == null

  const [t] = useTranslation('participants')

  //------
  // Rendering

  function render() {
    if (participant == null) { return null }

    return (
      <>
        <AppLayoutConfig
          title={t('profile.title')}
          fetchStatus={fetching ? 'fetching' : 'done'}
        />
        <Scroller contentAlign='center' contentPadding={layout.padding.m}>
          {fetching ? (
            <EmptyOrFetching
              status='fetching'
              flex
            />
          ) : (
            <ParticipantProfile
              participant={participant}
              editable={true}
            />
          )}
        </Scroller>
      </>
    )
  }

  return render()

})

export default ProfileScreen